import baseApi, {
    transformResponseFromData,
    // transformResponseFromMessage,
    provideTags,
    provideTag,
} from 'store/slices/api/baseApi'

const accountsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAccounts: build.query({
            query: () => ({url: 'accounts', method: 'GET'}),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTags('Account', result),
        }),
        getAccount: build.query({
            query: ({accountId}) => ({
                url: `accounts/${accountId}`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTag('Account', result),
        }),
        createAccount: build.mutation({
            query: ({name}) => {
                return {
                    url: `accounts`,
                    method: 'POST',
                    body: {name},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTags('Account'),
        }),
        saveAccount: build.mutation({
            query: (account) => {
                return {
                    url: `accounts/${account._id}`,
                    method: 'PUT',
                    body: account,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Account', result),
        }),
        deleteAccount: build.mutation({
            query: ({accountId}) => {
                return {
                    url: `accounts/${accountId}`,
                    method: 'DELETE',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Account'),
        }),
        inviteToAccount: build.mutation({
            query: ({accountId, userId, role}) => {
                return {
                    url: `accounts/invite`,
                    method: 'POST',
                    body: {accountId, userId, role},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Account', result),
        }),
        confirmAccount: build.mutation({
            query: ({accountId}) => {
                return {
                    url: `accounts/confirm/${accountId}`,
                    method: 'POST',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Account', result),
        }),
    }),
    overrideExisting: false,
})

export default accountsApi

export const {
    useGetAccountQuery,
    useGetAccountsQuery,
    useCreateAccountMutation,
    useSaveAccountMutation,
    useDeleteAccountMutation,
    useInviteToAccountMutation,
    useConfirmAccountMutation,
} = accountsApi
